import script from "./TermsAndConditionsEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsAndConditionsEdit.vue?vue&type=script&setup=true&lang=js"

import "./TermsAndConditionsEdit.vue?vue&type=style&index=0&id=03ad63ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03ad63ac"]])

export default __exports__